export default __webpack_public_path__ + "static/media/toilet-male.inline.7e85c235.svg";